import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  messageContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: '2rem 3rem',
    wordBreak: 'keep-all!important',
    borderRadius: '0.2rem',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  refreshButton: {
    marginTop: '1rem',
    cursor: 'pointer',
  },
}));

export { useStyles };
